//To clear all the selected filter
document.addEventListener("DOMContentLoaded", function() {
  const clearAllBtn = document.querySelector('.collection-filter--clear-all');

  if (!clearAllBtn) {
      return;
  }

  document.addEventListener("click", function(event) {
      if (event.target.closest('.collection-filter--clear-all')) {
          document.querySelectorAll('.tag').forEach(element => {
              element.classList.remove('tag--active');
          });

          document.querySelectorAll('.tag__input').forEach(input => {
              input.checked = false;
              input.removeAttribute("checked");
          });

          const url = new URL(window.location.href);
          const params = new URLSearchParams(url.search);

          [...params.keys()].forEach(key => {
              if (key.includes("filter")) {
                  params.delete(key);
              }
          });

          url.search = params.toString();
          window.history.replaceState({}, document.title, url.toString());

          location.reload();
      }
  });
});


//To highlist the current collection
document.addEventListener('DOMContentLoaded', function () {
  const collectionLinks = document.querySelectorAll('.sub-collections--info');
  const currentUrl = window.location.href.split('?');
  const newURl = currentUrl[0];

  const normalizeUrl = (url) => new URL(url, window.location.origin).href;

  collectionLinks.forEach((collectionLink) => {
    const collectionUrl = collectionLink.getAttribute('data-collection-url');

    if (normalizeUrl(collectionUrl) === normalizeUrl(newURl)) {
      collectionLink.style.pointerEvents = 'none';
      collectionLink.classList.add('highlight');
    } else {
      collectionLink.style.pointerEvents = 'auto';
      collectionLink.classList.remove('highlight');
    }
  });

});

//Back to top
document.addEventListener('DOMContentLoaded', function () {
    const backToTopButton = document.querySelector('.collection-page__back-top');
  
    const toggleButton = () => {
      if (window.scrollY > 400) {
        backToTopButton.classList.add('visible');
      } else {
        backToTopButton.classList.remove('visible');
      }
    };
  
    backToTopButton.addEventListener('click', function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
    window.addEventListener('scroll', toggleButton);
  
    toggleButton();
  });

//For the sort filters
document.addEventListener('DOMContentLoaded', function () {
    const sortTrigger = document.querySelector(".collection-filter__mobile-container");
    const sortDrawer = document.getElementById("sortDrawer");
    const selectBox = document.getElementById("SortBy");
    const options = document.querySelectorAll("#sortDrawer li");
    const sortText = document.querySelector(".collection-filter__text");
    const sortContainer = document.querySelector(".collection-filter__item--mobile");

    if (!sortTrigger || !sortDrawer || !selectBox) return;

    sortText.textContent = "Sort";
    const activeOption = document.querySelector("#sortDrawer li.active");
    if (activeOption) {
        sortText.textContent = activeOption.textContent;
        if(activeOption.textContent.includes('Price')){
          sortContainer.classList.add('flex-space');
        }
    }

    sortTrigger.addEventListener("click", function (event) {
        event.stopPropagation(); 
        sortDrawer.classList.toggle("open");
        // console.log(sortDrawer.classList.contains("open") ? "is open" : "is closed");
    });

    sortDrawer.addEventListener("click", function (event) {
        const selectedOption = event.target.closest("li");
        if (!selectedOption) return;

        selectBox.value = selectedOption.getAttribute("data-value");
        options.forEach(option => option.classList.remove("active"));
        selectedOption.classList.add("active");
        sortDrawer.classList.remove("open");
        selectBox.dispatchEvent(new Event("change"));
    });

    document.addEventListener("scroll", function () {
            sortDrawer.classList.remove("open");        
    });

    document.addEventListener("click", function (event) {
      if (!sortTrigger.contains(event.target) && !sortDrawer.contains(event.target)) {
          sortDrawer.classList.remove('open');
      }
  });
}); 